import { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { insurancePackagesDetailedQuery } from "../queries";

export const useInsuranceData = (show, data, rvId, rentalType) => {
  const [insuranceData, setInsuranceData] = useState(null);
  const [loading, setLoading] = useState(false);

  const [getInsurancePackages] = useLazyQuery(insurancePackagesDetailedQuery, {
    fetchPolicy: "no-cache",
    onCompleted: (result) => {
      if (result?.insurance_packages_detailed?.data) {
        setInsuranceData(result.insurance_packages_detailed.data);
      }
      setLoading(false);
    },
    onError: (error) => {
      console.error('Error fetching insurance packages:', error);
      setLoading(false);
    }
  });

  useEffect(() => {
    if (show) {
      if (data && data.groups && data.plans) {
        setInsuranceData(data);
      }
      else if (rvId && !data) {
        setLoading(true);
        getInsurancePackages({
          variables: { rv: rvId, rental_type: rentalType }
        });
      }
      else {
        setInsuranceData({
          groups: [],
          plans: []
        });
      }
    }
  }, [show, data, rvId]); // eslint-disable-line react-hooks/exhaustive-deps

  const currentData = insuranceData || {
    groups: [],
    plans: []
  };

  return {
    currentData,
    loading
  };
};
